import { getFacilityTypeById } from "../../services/shared";
import { convertToCountrySpecificId } from "../../utils/common";

const facilities = [
  {
    id: 1,
    name: "Hospital",
    types: [101, 102],
  },
  {
    id: 101,
    name: "Public Hospital",
  },
  {
    id: 102,
    name: "Private Medical Centre",
  },
  {
    id: 5,
    name: "Clinic",
    types: [501, 502, 503, 504],
  },
  {
    id: 501,
    name: "General Practitioner Clinic",
  },
  {
    id: 502,
    name: "Specialist Clinic",
  },
  {
    id: 503,
    name: "Dental Clinic",
  },
  {
    id: 504,
    name: "Community Clinic (Klinik Kesihatan)",
  },
  {
    id: 2,
    name: "Laboratory",
    types: [201, 202, 203],
  },
  {
    id: 201,
    name: "Independent Laboratory",
  },
  {
    id: 202,
    name: "Chain Laboratory",
  },
  {
    id: 203,
    name: "Hospital Laboratory",
  },
  {
    id: 3,
    name: `Pharmacy`,
    types: [301, 302, 303],
  },
  {
    id: 301,
    name: `Independent Retail Pharmacy`,
  },
  {
    id: 302,
    name: `Chain Retail Pharmacy`,
  },
  {
    id: 303,
    name: `Hospital Pharmacy`,
  },
  {
    id: 4,
    name: `Diagnostic Centre`,
    types: [401, 402, 403],
  },
  {
    id: 401,
    name: `Radiology / Imaging Centre`,
  },
  {
    id: 402,
    name: `Wellness and Executive health screening centre`,
  },
  {
    id: 403,
    name: `Wellness Centre`,
  },
  {
    id: 9,
    name: `Day-Care Centre`,
    types: [901, 902, 903],
  },
  {
    id: 901,
    name: `Medical Day-care Centre`,
  },
  {
    id: 902,
    name: `Elderly Daycare Centre`,
  },
  {
    id: 903,
    name: `Childcare/Paediatric Daycare Centre`,
  },
  {
    id: 6,
    name: `Rehabilitation Centre`,
    types: [601, 602, 603],
  },
  {
    id: 601,
    name: `Ambulatory and Physical Therapy Centre`,
  },
  {
    id: 602,
    name: `Mental Health and Counselling Centre`,
  },
  {
    id: 603,
    name: `Addiction Rehabilitation Centre`,
  },
  {
    id: 7,
    name: `Nursing Home`,
    types: [701, 702, 703],
  },
  {
    id: 701,
    name: `Hospice and Palliative Care Centre`,
  },
  {
    id: 702,
    name: `Private Nursing Home`,
  },
  {
    id: 703,
    name: `Caregiver Services Centre`,
  },
  {
    id: 8,
    name: `Dialysis Centre`,
    types: [801, 802],
  },
  {
    id: 801,
    name: `Public Dialysis Centre`,
  },
  {
    id: 802,
    name: `Private Dialysis Centre`,
  },
  {
    id: 10,
    name: `Other Healthcare Centre`,
    types: [1001, 1002, 1003, 1004, 1005],
  },
  {
    id: 1001,
    name: `Telehealth Centre`,
  },
  {
    id: 1002,
    name: `Charity Healthcare Centre`,
  },
  {
    id: 1003,
    name: `Blood Bank Centre`,
  },
  {
    id: 1004,
    name: `Ambulance and Emergency services`,
  },
  {
    id: 1005,
    name: `Other`,
  },
];

export const getFacilityType = async (code, country = 'MY') => {
  if (code) {
    if (code?.length > 1) {
      code = code[0];
    }
    
    try {
      // Convert old IDs to new country-specific IDs if needed
      const parsedCode = parseInt(code);
      let facilityId = parsedCode;
      
      // Check if it's an old ID format (< 1000)
      if (parsedCode < 1000) {
        facilityId = convertToCountrySpecificId(parsedCode, country);
      }
      
      const response = await getFacilityTypeById(facilityId, country);
      return response.data?.data?.name || "Unknown";
    } catch (error) {
      console.error('Failed to fetch facility type:', error);
      return "Unknown";
    }
  }
  return "Unknown";
};

export default facilities;
